import paneldetails from '../paneldetails/paneldetails.vue'
import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
import tableoccourenciadetails from '../tableoccourenciadetails/tableoccourenciadetails.vue'
import addCoordinator from '../addCoordinator/addCoordinator.vue'
import tableCreditUpdate from '../tableCreditUpdate/tableCreditUpdate.vue'
import MiscellaneousExpensesRepository from '@/shared/http/repositories/business/miscellaneousexpenses'
import paneldetailsdespesas from '../paneldetailsdespesas/paneldetailsdespesas.vue'
import LogDespesa from '../LogDespesa/LogDespesa.vue'
import Tools from '@/components/tools/Tools'
import { loading, toast } from '@/shared/utils/UIHelper'
import EmployeeRepository from '@/shared/http/repositories/business/employee.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import AccountMixin from '@/store/module/account/mixin'
import PermissionMixin from '@/store/module/permission/mixin'
import Roles from '@/shared/utils/roles.js'

export default {
  name: 'detailsmiscellaneousreimbursement',
  props: ['despesasid', 'dataDetails', 'arrayFuncionarios', 'tableGrids', 'filtroEmpresa'],
  emits: ['totalFuncionarioDespesas'],
  components: {paneldetails, HeadDetailsGama, tableoccourenciadetails, tableCreditUpdate, paneldetailsdespesas, addCoordinator, LogDespesa},
  data () {
    return {
      TipoReprova: false,
      flagDetailsDespesa: false,
      UnicaDespesa: false,
      motivo: null,
      despesaid: null,
      datadespesa: {},
      datadespesaEdit: {
        statusDespesa: 0,
        DateRegistro: null
      },
      dataAllSubCategoria: [],
      tabIndex: 0,
      funcionarioVinculados: [],
      editfuncionario: null,
      stringFile: null,
      StatusNotEdit: true,
      totalFuncionarioDespesas: null,
      empresaid: null,
      funcionariolistainicio: [],
      funcionarioarray: [],
      paneldetailfilter: {},
      StatusNotEditButon: true,
      definitivo: false,
      titleReprovacao: null,
      saldoadiantamento: false,
      impedeDevolucao: false,
      detailsExpense: {},
      despesaDetails: {},
      motivoimpedeDevolucao: {},
      motivoBloqueio: null,
      despesasidEnviarCoordenador: [],
      usuarioGrupoDV: {},
      arrayids: [],
      allDespesas: []
    }
  },
  mixins: [ActionsForm, AccountMixin, PermissionMixin],
  watch: {
    'datadespesaEdit.statusDespesa': function (value) {
      // Admin edita em qualquer status, EXCETO Diretoria (3).
      if (this.hasRole(this.roles.RW_REAL_ESTA_ADMIN)) {
        this.StatusNotEdit = value === 3
        this.StatusNotEditButon = value !== 3
        return
      }
      if (value === 1) {
        if (this.hasRole(Roles.ACC_FIN_MISCELLANEOUS_SEARCH_CONTROLLER_APPROVAL)) {
          this.StatusNotEdit = true
          this.StatusNotEditButon = false
        }
        if (this.hasRole(Roles.ACC_FIN_MISCELCOORDINATORLANEOUS_SEARCH_CONTROLLER_APPROVAL)) {
          this.StatusNotEdit = false
        }
      } else if (value === 3) {
        this.StatusNotEdit = true
        this.StatusNotEditButon = false
      } else if (value === 2) {
        if (this.hasRole(Roles.ACC_FIN_MISCELLANEOUS_SEARCH_CONTROLLER_APPROVAL)) {
          this.StatusNotEdit = false
        }
      }
    },
    onLoadFuncionario (data) {
      this.$refs.tableoccourenciadetails.GetDespesasByFuncioarioId(data)
    }
  },
  computed: {
    allInDirectoryStatus () {
      // Mostra o botão Revisar se existe ao menos uma despesa em status AG APROVAÇÃO DIRETORIA
      // na lista geral carregada do funcionário (independente de marcação).
      return Array.isArray(this.allDespesas) && this.allDespesas.some((d) => d && d.statusDespesa === 3)
    },
    // ZC-44: os ids que a GRID carregou, que são os que a aba Log pede ao servidor. Sai do
    // `despesasLoaded` do tableoccourenciadetails, então acompanha perfil, filtro e paginação sem
    // este componente ter de saber nada disso.
    idsDasDespesasNaGrid () {
      return Array.isArray(this.allDespesas) ? this.allDespesas.map((d) => d && d.id).filter(Boolean) : []
    }
  },
  mounted () {
    this.totalDespesa(this.dataDetails)
  },
  methods: {
    totalDespesa (obj) {
      let status = obj.statusDespesa
      let AgDiretoria = false
      if (status === 3) {
        AgDiretoria = true
      }
      MiscellaneousExpensesRepository.TotalDespesaPorFuncionarioID({FuncionarioId: obj.funcionarioId, EmpresaId: this.CompanySelected, AgDiretoria: AgDiretoria})
        .then((Response) => {
          this.totalFuncionarioDespesas = Response.data.length > 0 ? Response.data[0].valorGasto : 0
        })

      MiscellaneousExpensesRepository.GetUsuarioGrupoDespesaViagem()
        .then((Response) => {
          this.usuarioGrupoDV = Response.data.data
        })
    },
    eventcheck (arrayids) {
      this.arrayids = arrayids
    },
    onDespesasLoaded (lista) {
      this.allDespesas = Array.isArray(lista) ? lista : []
    },
    openReviewModal () {
      let selecionadas = Array.isArray(this.arrayids) ? this.arrayids.filter((d) => d && d.statusDespesa === 3).map((d) => d.id) : []
      if (selecionadas.length === 0) {
        toast.warning('Selecione despesas em status AG APROVAÇÃO DIRETORIA!')
        return
      }
      this.$refs['modal-review-confirm-diversos'].show()
    },
    closeReviewModal () {
      this.$refs['modal-review-confirm-diversos'].hide()
    },
    confirmReview () {
      let selecionadas = Array.isArray(this.arrayids) ? this.arrayids.filter((d) => d && d.statusDespesa === 3).map((d) => d.id) : []
      if (selecionadas.length === 0) {
        toast.warning('Selecione despesas em status AG APROVAÇÃO DIRETORIA!')
        this.closeReviewModal()
        return
      }
      loading.push()
      MiscellaneousExpensesRepository.ReviewExpensesByDirectory({ despesasIds: selecionadas })
        .then((Response) => {
          loading.pop()
          this.closeReviewModal()
          let r = Response.data || {}
          let revisadas = (r.revisadas || []).length
          let removidasDoLote = (r.removidasDoLote || []).length
          let ignoradasComLote = (r.ignoradasComLote || []).length
          let ignoradasStatusInvalido = (r.ignoradasStatusInvalido || []).length

          if (revisadas > 0) {
            let msg = revisadas + ' despesa(s) retornada(s) para Controladoria/Transportes'
            if (removidasDoLote > 0) msg += ' — ' + removidasDoLote + ' removida(s) do lote'
            toast.success(msg)
          }
          if (ignoradasComLote > 0) {
            toast.warning(ignoradasComLote + ' despesa(s) ignorada(s): já estão em lote gerado')
          }
          if (ignoradasStatusInvalido > 0) {
            toast.warning(ignoradasStatusInvalido + ' despesa(s) ignorada(s): status diferente de AG APROVAÇÃO DIRETORIA')
          }
          if (revisadas === 0 && ignoradasComLote === 0 && ignoradasStatusInvalido === 0) {
            toast.warning('Nenhuma despesa retornada')
          }
          this.arrayids = []
          // Se algo foi revisado, volta pra grid principal ja filtrada por AG APROVACAO DIRETORIA
          if (revisadas > 0) {
            this.$emit('tableGrids', { applyDirectoryFilter: true })
          } else if (this.$refs.tableoccourenciadetails && typeof this.$refs.tableoccourenciadetails.GetDespesasByFuncioarioId === 'function') {
            // Senao, so recarrega a lista atual
            this.$refs.tableoccourenciadetails.GetDespesasByFuncioarioId(this.paneldetailfilter)
          }
        })
        .catch((Error) => {
          loading.pop()
          this.closeReviewModal()
          toast.error('Erro ao retornar despesas')
        })
    },
    onLoadFuncionario (data) {
      this.paneldetailfilter = data
      this.$refs.tableoccourenciadetails.GetDespesasByFuncioarioId(data)
    },
    popUpAtualizaCredito () {
      this.$refs['atualizaCredito'].show()
    },
    cancelAjuste () {
      this.$refs['atualizaCredito'].hide()
    },
    fecharEnviarCoordenador () {
      this.$refs['modal-envio-coordenador'].hide()
    },
    salvaAltercaoCredito () {
      this.$refs['atualizaCredito'].hide()
      this.$refs['ConfirmacaoAtualizaCredito'].show()
    },
    continuarAtualizaocao () {
      this.$refs['ConfirmacaoAtualizaCredito'].hide()
    },
    detailsDespesa (data) {
      this.despesaid = data.id
      this.flagDetailsDespesa = true
      this.GetDespesasDiversosbyid(data.id)
      this.getAllCategoria()
      this.GetProofByDespesasViagemId(data.id)
    },
    GetDespesasDiversosbyid (id) {
      MiscellaneousExpensesRepository.GetDespesasDiversosbyid(id)
        .then((Response) => {
          this.datadespesa = Response.data
          Object.assign(this.datadespesaEdit, Response.data)
          this.funcionarioVinculados = []
          Object.assign(this.funcionarioVinculados, Response.data.funcionarioVinculados)
          this.verificafuncionario()
        })
    },
    downloadComprovante () {
      var a = document.createElement('a')
      const typefile = this.datadespesaEdit.midia.name.includes('.pdf') ? 'application/pdf' : 'image/png'
      a.href = `data:${typefile};base64,` + this.stringFile
      a.download = this.datadespesaEdit.midia.name
      a.click()
    },
    changeFuncionarioByCodigo (codigo, index) {
      loading.push()
      this.editfuncionario = index
      EmployeeRepository.codigoFuncionario(codigo.target.value)
        .then((Response) => {
          if (Response.data.code === 200) {
            let data = {
              id: Response.data.data.id,
              funcionario: {
                codigo: Response.data.data.codigo,
                nome: Response.data.data.nome
              }
            }
            this.funcionarioVinculados[this.editfuncionario] = data
            document.getElementById('form-funcionario-code-' + this.editfuncionario).value = data.funcionario.codigo
            document.getElementById('form-funcionario-text-' + this.editfuncionario).value = data.funcionario.nome
          } else {
            toast.error('Não foi possivel encontrar um funcionario!')
          }
          loading.pop()
        })
        .catch((Error) => {
          loading.pop()
        })
    },
    getAllCategoria () {
      MiscellaneousExpensesRepository.GetAllSubCategoria()
        .then((Response) => {
          this.dataAllSubCategoria = Response.data
        })
    },
    Modalaprovar (value) {
      this.$refs['modal-apr'].show()
    },
    ModalEnviarCoordenador () {
      let ids = null
      this.arrayids === undefined || this.arrayids == null ? ids = this.$refs.tableoccourenciadetails.getselected() : this.arrayids.length !== 0 ? ids = this.arrayids : ids = this.$refs.tableoccourenciadetails.getselected()
      let idsFiltrados = ids.map(item => item.id)
      let coordenadorIdFiltrados = ids.map(item => item.coordenadorID)

      let mesmaQuantidade = idsFiltrados.length === coordenadorIdFiltrados.length

      let todosPreenchidos = coordenadorIdFiltrados.every(id => id !== null && id !== undefined && id !== '')

      if (mesmaQuantidade && todosPreenchidos) {
        this.ToApproveContraladoria()
      } else {
        if (this.hasRole(this.roles.ACC_FIN_MISCELTECHNICIANLANEOUS_SEARCH_CONTROLLER_APPROVAL)) {
          this.despesasidEnviarCoordenador = idsFiltrados
          this.$refs['modal-envio-coordenador'].show()
        } else {
          toast.warning('As despesas não podem ser enviadas!')
        }
      }
    },
    modalEnviaCoordenadorUnicaDespesa () {
      this.UnicaDespesa = true
      this.despesasidEnviarCoordenador = this.despesaid
      this.$refs['modal-envio-coordenador'].show()
    },
    closemodalAprovar () {
      this.$refs['modal-apr'].hide()
    },
    formatMoney (value) {
      return Tools.formatMoney(value)
    },
    formatMoneyHtml () {
      return Tools.moneyFormatHtml()
    },
    ModalReporvar () {
      this.$refs['modal-rep'].show()
    },
    closeModalReprovar () {
      this.$refs['modal-rep'].hide()
    },
    backAllDespesas () {
      console.log('ENTROU')
      this.flagDetailsDespesa = false
    },
    UpdateDespesasDiversos () {
      if (this.datadespesaEdit.statusDespesa !== 3) {
        loading.push()
        let funcionarioids = this.funcionarioVinculados.map((Element) => {
          if (Element.id !== undefined) {
            return Element.id
          }
        })
        this.datadespesaEdit.DateRegistro = this.datadespesa.dataRegistroDespesa
        this.datadespesaEdit['Funcionarioids'] = funcionarioids.filter((Element) => Element !== undefined)
        MiscellaneousExpensesRepository.UpdateDespesasDiversos(this.datadespesaEdit)
          .then((Response) => {
            loading.pop()
            toast.success('Alteração Realizado com sucesso')
            this.flagDetailsDespesa = false
          })
          .catch((Error) => {
            loading.pop()
            toast.warning(Error)
          })
      } else {
        toast.info('Não é possivel editar despesas em Ag. Diretoria')
      }
    },
    Reprove (ReprovacaoDefinitiva) {
      loading.push()
      let fluxo = null
      if (this.hasRole(this.roles.RW_REAL_ESTA_ADMIN) || this.hasRole(this.roles.ACC_FIN_MISCELLANEOUS_SEARCH_CONTROLLER_APPROVAL)) {
        fluxo = 2
      }
      if (this.hasRole(this.roles.ACC_FIN_MISCELCOORDINATORLANEOUS_SEARCH_CONTROLLER_APPROVAL)) {
        fluxo = 1
      }
      if (this.hasRole(this.roles.ACC_FIN_MISCELTECHNICIANLANEOUS_SEARCH_CONTROLLER_APPROVAL)) {
        fluxo = 0
      }
      if (ReprovacaoDefinitiva === true) {
        this.TipoReprova = true
      }
      MiscellaneousExpensesRepository.Reprove({motivoRecusa: this.motivo, despesasdiversosid: this.despesaid, Fluxo: fluxo, ReprovacaoDefinitiva: this.TipoReprova})
        .then((Response) => {
          this.voltarEscolhaReprova()
          this.voltar()
          this.closemodalAprovar()
          this.$emit('tableGrids')
          this.TipoReprova = false
          this.totalDespesa(this.dataDetails)
          /// this.$refs.tableoccourenciadetails.uncheckAllCheckboxes()
          this.GetDespesasDiversosbyid(this.despesaid)
          loading.pop()
          this.$refs['devolver-despesa'].hide()
          this.$refs['modal-EscolhaReprovaUnica'].hide()
          this.despesaid = null
          toast.success('Despesas reprovada com sucesso!')
        })
        .catch((Error) => {
          this.TipoReprova = false
          loading.pop()
          toast.error('Erro ao reprovar a despesa!')
        })
    },
    openDetailsimg () {
      this.$refs['Detailsimg'].show()
    },
    fechaModalAprovacaoEnvioCoordenador () {
      this.closemodalAprovar()
      this.$emit('tableGrids')
    },
    NextStatus () {
      loading.push()
      MiscellaneousExpensesRepository.NextStatus(this.despesaid)
        .then((Response) => {
          this.closemodalAprovar()
          toast.success('Aprovado com sucesso')
          this.$emit('tableGrids')
          loading.pop()
        })
        .catch((Error) => {
          loading.pop()
        })
    },
    modalDevolucaoUnicaDespesa (Response) {
      this.despesaDetails = Response
      this.UnicaDespesa = true
      this.$refs['modal-EscolhaReprovaUnica'].show()
    },
    modalDevolucaoUnicaDespesaDevolver () {
      this.definitivo = false
      this.$refs['devolver-despesa'].show()
    },
    modalDevolucaoUnicaDespesaDefinitivo () {
      this.definitivo = true
      this.$refs['devolver-despesa'].show()
    },
    onloadReacarregar () {
      this.onLoadFuncionario(null)
      this.$refs['modal-envio-coordenador'].hide()
    },
    modalEscolhaReprova () {
      let ids = null
      this.UnicaDespesa = false
      let idsSelecionados = this.$refs.tableoccourenciadetails.getselected()
      console.log(idsSelecionados)
      this.arrayids === undefined || this.arrayids == null ? ids = this.$refs.tableoccourenciadetails.getselected() : this.arrayids.length !== 0 ? ids = this.arrayids : ids = this.$refs.tableoccourenciadetails.getselected()
      ids.forEach((Element) => {
        if (Element.statusDespesa === 2 && (this.hasRole(this.roles.RW_REAL_ESTA_ADMIN) || this.hasRole(this.roles.ACC_FIN_MISCELLANEOUS_SEARCH_CONTROLLER_APPROVAL))) {
          if (idsSelecionados != null || idsSelecionados !== undefined) {
            this.verificaDevolucao(idsSelecionados)
            this.$refs['modal-EscolhaReprova'].show()
          }
        } else if (Element.statusDespesa === 1 && (this.hasRole(this.roles.ACC_FIN_MISCELCOORDINATORLANEOUS_SEARCH_CONTROLLER_APPROVAL))) {
          if (idsSelecionados != null || idsSelecionados !== undefined) {
            this.$refs['modal-EscolhaReprova'].show()
          }
        } else if (Element.statusDespesa === 9 && (this.hasRole(this.roles.ACC_FIN_MISCELTECHNICIANLANEOUS_SEARCH_CONTROLLER_APPROVAL))) {
          if (idsSelecionados != null || idsSelecionados !== undefined) {
            this.$refs['modal-EscolhaReprova'].show()
          }
        } else {
          toast.warning('Selecione uma despesa válida para a reprovação')
        }
      })
    },
    verificaDevolucao (Response) {
      let filteredData = Response.filter((obj) => obj.primeiroAdiantamento || obj.saldo || obj.reforco || obj.reforcoDescontar)
      filteredData.map(obj => {
        let categoriaMotivo = ''
        if (obj.saldo) {
          categoriaMotivo = 'Saldo Inicial'
        }
        if (obj.primeiroAdiantamento) {
          categoriaMotivo = 'Primeiro Adiantamento'
        }
        if (obj.reforco) {
          categoriaMotivo = 'Reforço Creditado'
        }
        if (obj.reforcoDescontar) {
          categoriaMotivo = 'Reforço Descontar'
        }
        this.motivoBloqueio = categoriaMotivo
      })
      let checkIsArray = Array.isArray(Response)
      if (checkIsArray === true) {
        if (Response.some(obj => obj.primeiroAdiantamento || obj.saldo || obj.reforco || obj.reforcoDescontar)) {
          this.motivoimpedeDevolucao = Response.push((obj) => obj.primeiroAdiantamento || obj.saldo || obj.reforco || obj.reforcoDescontar)
          this.impedeDevolucao = true
        } else {
          this.impedeDevolucao = false
        }
      } else {
        if (Response.primeiroAdiantamento || Response.saldo || Response.reforco || Response.reforcoDescontar) {
          this.despesaid = Response.id
          console.log(Response)
          this.impedeDevolucao = true
        } else {
          this.impedeDevolucao = false
        }
      }
    },
    modal () {
      this.definitivo = false
      let ids = this.$refs.tableoccourenciadetails.getselected()
      if (ids != null || ids !== undefined) {
        this.$refs['devolver-despesa'].show()
      }
    },
    modalDefinitivo () {
      this.definitivo = true
      let ids = this.$refs.tableoccourenciadetails.getselected()
      if (ids != null || ids !== undefined) {
        this.$refs['devolver-despesa'].show()
      }
    },
    voltarEscolhaReprova () {
      this.$refs['modal-EscolhaReprova'].hide()
    },
    voltar () {
      this.motivo = null
      this.$refs['devolver-despesa'].hide()
    },
    ReproachContraladoria (ReprovacaoDefinitiva) {
      loading.push()
      let data = new FormData()
      let ids = this.$refs.tableoccourenciadetails.getselected()
      let idsDespesa = ids.map(item => item.id)

      if (ReprovacaoDefinitiva === true) {
        this.TipoReprova = true
      }
      this.arrayids === undefined || this.arrayids == null ? ids = this.$refs.tableoccourenciadetails.getselected() : this.arrayids.length !== 0 ? ids = this.arrayids : ids = this.$refs.tableoccourenciadetails.getselected()
      ids.forEach((Element) => {
        data.append('despesasdiversoids', Element.id)
        if (Element.statusDespesa === 2 && (this.hasRole(this.roles.RW_REAL_ESTA_ADMIN) || this.hasRole(this.roles.ACC_FIN_MISCELLANEOUS_SEARCH_CONTROLLER_APPROVAL))) {
          let selectedItems = this.$refs.tableoccourenciadetails.getselected()
          let filteredItems = selectedItems.filter(item => item.statusDespesa === 2).map(item => item.id)
          MiscellaneousExpensesRepository.ReproachContraladoria({motivoRecusa: this.motivo, Fluxo: 2, despesasdiversoids: filteredItems, despesaviagemids: idsDespesa, ReprovacaoDefinitiva: this.TipoReprova})
            .then((Response) => {
              loading.pop()
              this.voltar()
              this.voltarEscolhaReprova()
              this.totalDespesa(this.dataDetails)
              this.TipoReprova = false
              this.onLoadFuncionario(null)
              this.$refs.tableoccourenciadetails.checkfalse()
              this.$refs.tableoccourenciadetails.uncheckAllCheckboxes()
              toast.success('Despesa Reprovada com sucesso')
            })
            .catch((Error) => {
              loading.pop()
              this.voltar()
              this.voltarEscolhaReprova()
              this.TipoReprova = false
              toast.error('Erro ao Reprovar a Despesa')
            })
        } else if ((Element.statusDespesa === 1 && (this.hasRole(this.roles.ACC_FIN_MISCELCOORDINATORLANEOUS_SEARCH_CONTROLLER_APPROVAL)))) {
          let selectedItems = this.$refs.tableoccourenciadetails.getselected()
          let filteredItems = selectedItems.filter(item => item.statusDespesa === 1).map(item => item.id)
          MiscellaneousExpensesRepository.ReproachContraladoria({motivoRecusa: this.motivo, Fluxo: 1, despesasdiversoids: filteredItems, despesaviagemids: idsDespesa, ReprovacaoDefinitiva: this.TipoReprova})
            .then((Response) => {
              loading.pop()
              this.voltarEscolhaReprova()
              this.totalDespesa(this.dataDetails)
              this.voltar()
              this.TipoReprova = false
              this.$refs.tableoccourenciadetails.uncheckAllCheckboxes()
              this.$refs.tableoccourenciadetails.checkfalse()
              this.onLoadFuncionario(null)
              toast.success('Despesa Reprovada com sucesso')
            })
            .catch((Error) => {
              loading.pop()
              this.voltarEscolhaReprova()
              this.TipoReprova = false
              toast.error('Erro ao Reprovar a Despesa')
            })
        } else if ((Element.statusDespesa === 9 && (this.hasRole(this.roles.ACC_FIN_MISCELTECHNICIANLANEOUS_SEARCH_CONTROLLER_APPROVAL)))) {
          let selectedItems = this.$refs.tableoccourenciadetails.getselected()
          let filteredItems = selectedItems.filter(item => item.statusDespesa === 9).map(item => item.id)
          MiscellaneousExpensesRepository.ReproachContraladoria({motivoRecusa: this.motivo, Fluxo: 0, despesasdiversoids: filteredItems, despesaviagemids: idsDespesa, ReprovacaoDefinitiva: this.TipoReprova})
            .then((Response) => {
              loading.pop()
              this.voltarEscolhaReprova()
              this.totalDespesa(this.dataDetails)
              this.voltar()
              this.TipoReprova = false
              this.$refs.tableoccourenciadetails.uncheckAllCheckboxes()
              this.$refs.tableoccourenciadetails.checkfalse()
              this.onLoadFuncionario(null)
              toast.success('Despesa Reprovada com sucesso')
            })
            .catch((Error) => {
              loading.pop()
              this.voltarEscolhaReprova()
              this.TipoReprova = false
              toast.error('Erro ao Reprovar a Despesa')
            })
        } else {
          this.voltar()
          this.voltarEscolhaReprova()
          this.TipoReprova = false
          toast.warning('Despesa AG. APROVAÇÃO DO COORDENADOR, AG. APROVAÇÃO DO TÉCNICO e AG. APROVAÇÃO DA DIRETORIA não podem ser reprovadas')
          loading.pop()
        }
      })
    },
    ToApproveContraladoria () {
      loading.push()
      let ids = null
      this.arrayids === undefined || this.arrayids == null ? ids = this.$refs.tableoccourenciadetails.getselected() : this.arrayids.length !== 0 ? ids = this.arrayids : ids = this.$refs.tableoccourenciadetails.getselected()
      if (ids !== undefined && ids !== null) {
        ids.forEach((Element) => {
          let idsFilter = [Element.id] // ids.map(objeto => objeto.id)
          if (Element.statusDespesa === 2 && (this.hasRole(this.roles.RW_REAL_ESTA_ADMIN) || this.hasRole(this.roles.ACC_FIN_TRAVELREFUND_SEARCH_CONTROLLER_APPROVAL) || this.hasRole(this.roles.ACC_FIN_MISCELLANEOUS_SEARCH_CONTROLLER_APPROVAL))) {
            MiscellaneousExpensesRepository.ToApproveContraladoria({Fluxo: 2, despesaDiversosids: idsFilter})
              .then((Response) => {
                loading.pop()
                this.totalDespesa(this.dataDetails)
                this.onLoadFuncionario(null)
                this.$refs.tableoccourenciadetails.checkfalse()
                this.$refs.tableoccourenciadetails.uncheckAllCheckboxes()
                toast.success('Despesa Aprovada com Sucesso!!')
              })
              .catch((Error) => {
                loading.pop()
                toast.error('Erro ao Aprovar a Despesa')
              })
          } else if (Element.statusDespesa === 1 && (this.hasRole(this.roles.ACC_FIN_MISCELCOORDINATORLANEOUS_SEARCH_CONTROLLER_APPROVAL))) {
            MiscellaneousExpensesRepository.ToApproveContraladoria({Fluxo: 1, despesaDiversosids: idsFilter})
              .then((Response) => {
                loading.pop()
                this.totalDespesa(this.dataDetails)
                this.$refs.tableoccourenciadetails.checkfalse()
                this.$refs.tableoccourenciadetails.uncheckAllCheckboxes()
                this.onLoadFuncionario(null)
                toast.success('Despesa Aprovada com Sucesso!!')
              })
              .catch((Error) => {
                loading.pop()
                toast.error('Erro ao Aprovar a Despesa')
              })
          } else if (Element.statusDespesa === 9 && (this.hasRole(this.roles.ACC_FIN_MISCELTECHNICIANLANEOUS_SEARCH_CONTROLLER_APPROVAL))) {
            MiscellaneousExpensesRepository.ToApproveContraladoria({Fluxo: 0, despesaDiversosids: idsFilter})
              .then((Response) => {
                loading.pop()
                this.totalDespesa(this.dataDetails)
                this.$refs.tableoccourenciadetails.checkfalse()
                this.$refs.tableoccourenciadetails.uncheckAllCheckboxes()
                this.onLoadFuncionario(null)
                toast.success('Despesa Aprovada com Sucesso!!')
              })
              .catch((Error) => {
                loading.pop()
                toast.error('Erro ao Aprovar a Despesa')
              })
          } else {
            toast.warning('Despesa AG. APROVAÇÃO DO COORDENADOR, AG. APROVAÇÃO DO TÉCNICO e AG. APROVAÇÃO DA DIRETORIA não podem ser aprovadas')
            loading.pop()
          }
        })
      }
    },
    PreApprovedDespesaByid (datadespesa) {
      loading.push()
      MiscellaneousExpensesRepository.PreApprovedDespesaByid(datadespesa.id)
        .then((Response) => {
          loading.pop()
          toast.success('Despesa Pré-aprovada com Sucesso!!')
        })
        .catch((Error) => {
          loading.pop()
          toast.warning(Error)
        })
    },
    AddEmployer () {
      let data = {
        funcionario: {
          codigo: null,
          nome: null
        }
      }
      this.funcionarioVinculados.push(data)
    },
    GetProofByDespesasViagemId (id) {
      loading.push()
      MiscellaneousExpensesRepository.GetProofByDespesasViagemId(id, this.CompanySelected)
        .then((Response) => {
          loading.pop()
          this.stringFile = Response.data
        })
        .catch((Error) => {
          loading.pop()
        })
    },
    removerfuncionario (response) {
      this.funcionarioVinculados.splice(response, 1)
    },
    verificafuncionario () {
      this.funcionariolistainicio = this.funcionarioVinculados
      this.funcionarioarray = this.funcionarioVinculados
      let funcionariocolaborador = this.dataDetails.funcionarioId

      this.funcionarioarray.forEach((e, index) => {
        if (e.funcionarioID === funcionariocolaborador) {
          const funcionarioLogado = this.funcionarioarray.find((funcionario) => {
            return funcionario.funcionarioID === funcionariocolaborador
          })
          this.funcionarioarray.splice(index, 1)
          this.funcionarioarray.unshift(funcionarioLogado)
          this.$emit('arrayFuncionarios', this.funcionarioarray)
        }
      })
    },
    alertsStyle () {
      return {
        'button-disabled': this.impedeDevolucao === true,
        'button-info': this.impedeDevolucao === false
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/miscellaneousreimbursement/components/detailsmiscellaneousreimbursement/detailsmiscellaneousreimbursement.js